import axios from "axios";
import { RouterPath } from "../assets/dictionary/RouterPath";
import AuthService from "../components/auth/Service";
import { buildLoginUrl } from "./authRedirect";

let isConfigured = false;
let handlingLogout = false;
let isRefreshing = false;
const refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

function onRefreshed() {
    while (refreshSubscribers.length) {
        const cb = refreshSubscribers.shift();
        try { cb(); } catch (_) {}
    }
}

export function configureAxiosInterceptors() {
	if (isConfigured) return;
	isConfigured = true;

	axios.defaults.withCredentials = true;

	axios.interceptors.response.use(
		(response) => response,
		async (error) => {
			const status = error?.response?.status;
			const originalRequest = error.config;
			const url = originalRequest?.url || "";
			const isAuthEndpoint = url.includes("/login/refresh-token") || url.includes("/login/get-access-token") || url.includes("/logout");
			if ((status === 401 || status === 403) && !originalRequest?._retry && !isAuthEndpoint) {
				originalRequest._retry = true;
				if (!isRefreshing) {
					isRefreshing = true;
					AuthService.refresh()
						.then(() => {
							isRefreshing = false;
							onRefreshed();
						})
						.catch(async () => {
							isRefreshing = false;
							if (!handlingLogout) {
								handlingLogout = true;
								try { await AuthService.logout(); } catch (_) {}
								try { sessionStorage.setItem("auth_toast_msg", "Vous avez été déconnecté."); } catch (_) {}
								if (window.location.pathname !== RouterPath.LOGIN && window.location.pathname !== RouterPath.AUTH) {
									const next = window.location.pathname + window.location.search + window.location.hash;
									window.location.assign(buildLoginUrl(next));
								}
							}
						});
				}
				return new Promise((resolve, reject) => {
					subscribeTokenRefresh(() => {
						axios(originalRequest).then(resolve).catch(reject);
					});
				});
			}
			// If refresh endpoint itself failed with 401/403, logout once
			if ((status === 401 || status === 403) && isAuthEndpoint) {
				if (!handlingLogout) {
					handlingLogout = true;
					try { await AuthService.logout(); } catch (_) {}
					try { sessionStorage.setItem("auth_toast_msg", "Vous avez été déconnecté."); } catch (_) {}
					if (window.location.pathname !== RouterPath.LOGIN && window.location.pathname !== RouterPath.AUTH) {
						const next = window.location.pathname + window.location.search + window.location.hash;
						window.location.assign(buildLoginUrl(next));
					}
				}
			}
			return Promise.reject(error);
		}
	);
}


